import OpenLinkCardCta from './view';

export default OpenLinkCardCta;
